import { create } from 'zustand';

interface PasswordState {
  showPassword: boolean;
  passwordAttempt: number;
  password: string;
}

interface PasswordAction {
  toggleShowPassword: () => void;
  setValue<K extends keyof PasswordState>(
    key: K,
    value: PasswordState[K],
  ): void;
  clear(): void;
  setPasswordAttempt(): void;
}

type PasswordStateInitType = PasswordState & PasswordAction;

export const usePasswordStore = create<PasswordStateInitType>((set) => ({
  showPassword: false,
  password: '',
  passwordAttempt: +JSON.parse(localStorage.getItem('PASSWORD_ATTEMPT')!) || 0,
  toggleShowPassword: () =>
    set((state) => ({ showPassword: !state.showPassword })),
  setValue: (key, value) => {
    set((state) => ({ [key]: value }));
  },
  setPasswordAttempt: () => {
    set((state) => {
      const attempt = ++state.passwordAttempt;
      localStorage.setItem('PASSWORD_ATTEMPT', JSON.stringify(attempt));
      return {
        passwordAttempt: attempt,
      };
    });
  },
  clear: () => {
    set((state) => ({
      password: '',
      showPassword: false,
      passwordAttempt: 0,
    }));
  },
}));
